import React from 'react';
import { useTheme } from 'styled-components';

export const LocationSvg = (props) => {

  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "10"} height={height ?? "11"} viewBox="0 0 10 11" fill={color ?? theme?.colour?.primary ?? "#04333B"} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.75 4.99482C0.75 2.69488 2.67194 0.835938 4.99672 0.835938C7.32806 0.835938 9.25 2.69488 9.25 4.99482C9.25 6.15378 8.8285 7.22975 8.13475 8.14173C7.3694 9.1477 6.42608 10.0242 5.36427 10.7122C5.12126 10.8711 4.90194 10.8831 4.63522 10.7122C3.56737 10.0242 2.62404 9.1477 1.86525 8.14173C1.17099 7.22975 0.75 6.15378 0.75 4.99482ZM3.59712 5.12432C3.59712 5.89479 4.22583 6.50078 4.99673 6.50078C5.76812 6.50078 6.40289 5.89479 6.40289 5.12432C6.40289 4.35984 5.76812 3.72436 4.99673 3.72436C4.22583 3.72436 3.59712 4.35984 3.59712 5.12432Z" />
    </svg>
  )
}